import { useAction, useAtom } from '@reatom/npm-react'
import { css } from 'styled-components'

import { useHapticFeedback } from '@blade/ui-kit'
import { toggleFavoriteWalletAction } from '@root/features/wallet/favorite-wallet'
import { Star } from '@root/shared/ui-kit'

import type { WalletModel } from '@root/entities/wallet/atoms/reatom-wallet'

export const COLLAPSED_WALLET_ITEM_HEIGHT = 60

export type Props = {
  wallet: WalletModel
  size?: number
}

export const FavoriteWalletStar: React.FC<Props> = ({ wallet, size = 16 }) => {
  const haptics = useHapticFeedback()

  const [favorite] = useAtom(wallet.favorite)

  const toggleFavorite = useAction(toggleFavoriteWalletAction)

  const handleStarClick: React.MouseEventHandler = (e) => {
    e.stopPropagation()
    haptics.impactOccurred('light')
    toggleFavorite(wallet.id)
  }

  return (
    <Star
      css={css`
        cursor: pointer;
      `}
      onClick={handleStarClick}
      filled={favorite}
      size={size}
    />
  )
}
